import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { supabase } from "../utils/supabaseClient";
import Receipt from "../components/Receipt";
import { canShowReceipt } from "../utils/orderHelpers";

// Signed-in customers: the database policies decide which orders can be read
export default function ReceiptPage() {
  const { orderId } = useParams();
  const [state, setState] = useState({ status: "loading", order: null });

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setState({ status: "loading", order: null });

      if (!/^\d+$/.test(orderId ?? "")) {
        setState({ status: "notfound", order: null });
        return;
      }

      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (cancelled) return;

      if (!user) {
        setState({ status: "signin", order: null });
        return;
      }

      const { data, error } = await supabase
        .from("orders")
        .select(
          "id, email, total, delivery_fee, status, items, first_name, last_name, address, city, postcode, created_at, paid_at, stripe_payment_intent"
        )
        .eq("id", orderId)
        .maybeSingle();
      if (cancelled) return;

      if (error || !data) {
        setState({ status: "notfound", order: null });
      } else if (!canShowReceipt(data)) {
        setState({ status: "unpaid", order: data });
      } else {
        setState({ status: "ready", order: data });
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [orderId]);

  const { status, order } = state;

  if (status === "loading") {
    return (
      <div className="ord">
        <p className="adm-muted">Loading your receipt...</p>
      </div>
    );
  }

  if (status === "ready") {
    return (
      <>
        <div className="ord no-print" style={{ paddingBottom: 0 }}>
          <Link to="/account/orders" className="ord-back">Back to my orders</Link>
        </div>
        <Receipt order={order} />
      </>
    );
  }

  let heading = "We couldn't find that order";
  let text = "It may belong to a different account, or the link is wrong.";
  if (status === "signin") {
    heading = "Sign in to see your receipt";
    text = "Receipts are only shown to the customer who placed the order.";
  } else if (status === "unpaid") {
    heading = "No receipt yet";
    text = "A receipt is available once payment for this order has been confirmed.";
  }

  return (
    <div className="ord">
      <div className="shop-empty">
        <h3>{heading}</h3>
        <p>{text}</p>
        {status === "signin" ? (
          <Link to="/login" className="ui-btn ui-btn--primary">Sign in</Link>
        ) : (
          <Link to="/account/orders" className="ui-btn ui-btn--primary">Back to my orders</Link>
        )}
        <p style={{ marginTop: "1rem" }}>
          Ordered as a guest? <Link to="/order-lookup">Find your order</Link>
        </p>
      </div>
    </div>
  );
}